import { getInitialBreakpoints } from '@marketplace-web/shared/breakpoints'

export const deviceFromBreakpoints = () => {
  const breakpoints = getInitialBreakpoints()

  if (breakpoints.phones || breakpoints.tablets) return 'mobile'
  if (breakpoints.desktops) return 'desktop'

  return 'unknown'
}

type NavigatorWithConnection = Navigator & {
  connection?: {
    effectiveType?: 'slow-2g' | '2g' | '3g' | '4g'
  }
}

const isNavigatorWithConnection = (navigator: Navigator): navigator is NavigatorWithConnection =>
  'connection' in navigator && typeof navigator.connection === 'object'

const FALLBACK_CONNECTION_TYPE = 'unknown'

export const getEffectiveConnectionType = () => {
  if (!('navigator' in globalThis)) return FALLBACK_CONNECTION_TYPE
  if (!isNavigatorWithConnection(globalThis.navigator)) return FALLBACK_CONNECTION_TYPE

  return globalThis.navigator.connection?.effectiveType ?? FALLBACK_CONNECTION_TYPE
}
